<h2>{{subtitle}}</h2>

<div class="amount-bl" *transloco="let t">
    <span class="text-size-xxs text-muted"> {{t('card_content.card_subtitle_amount')}} </span>
    <span> ${{amount}} </span>
</div>
